export default __webpack_public_path__ + "static/rocket-08d70019a9eaf02de75606529a4b445e.jpeg";